const testingMixin = {
    data() {
        return {
            testing: {
                id: this.$route.params.id || '',
            },
            loadSelects: false,
            regPostAll: false,
            postAll: false,
            postGroupAll: false,
            tests: [],
            types: [],
            registerPostTypes: [],
            positionTypes: [],
            postGroups: [],
            statuses: [],
            forms: {
                question: {
                    id: '',
                }
            },
            filterForm: {
                page: Number.parseInt( this.$route.query.page ) || 1,
                typeId:this.$route.query.typeId || '',
                status: [],
                minLimit:''
            },
            form: {
                id: '',
                titleRu: '',
                titleKy: '',
                type:{},
                status: true,
                typeId: '',
                minLimit: 1,
                positionTypeIds: [],
                postGroupIds: [],
                registerPostTypeIds: [],
                documentCode: null,
            },
            questions: [],
            pagination: {
                total: '',
                lastPage: '',
                currentPage: ''
            },
        }
    },
    methods: {

        fetchTesting() {
            return this.axios.get( this.$config.urls.testing.fetchTest.url.replace( ':id', this.testing.id ) )
                       .then( response => {
                           this.testing = response.data.data;
                           return response.data.data;
                       } ).catch(()=>{});
        },
        fetchFormOptions( isMore ) {
            isMore = !!isMore;
            return this.axios.get( this.$config.urls.testing.fetchFormOptions.url, { params: { isMore: isMore } } )
                       .then( response => {
                           this.types = response.data.data.types;
                           this.registerPostTypes = response.data.data.registerPostTypes;
                           this.positionTypes = response.data.data.positionTypes;
                           this.postGroups = response.data.data.postGroups;
                           this.statuses = this.objectToArray( response.data.data.status, true );
                       } ).catch(()=>{});
        },
        fetchQuestions() {
            let filter = this.cleanObject( this.filterForm );
            this.axios.get( this.$config.urls.testing.fetchTestingQuestions.url.replace( ':id', this.testing.id ), { params: filter } )
                .then( response => {
                    this.questions = response.data.data;
                } ).catch(()=>{});
        },
        fetchTests() {
            let filter = this.cleanObject( {...this.filterForm} );

            if (filter.hasOwnProperty('minLimit'))
            {
                filter.minLimit = filter.minLimit == true ? 1:0;
            }

            this.axios.get( this.$config.urls.testing.fetchTests.url, { params: filter } ).then( response => {
                this.tests = response.data.data.items;
                this.pagination.currentPage = response.data.data.activePage;
                this.filterForm.page = response.data.data.activePage;
                this.pagination.total = response.data.data.totalItemsCount;
                this.pagination.lastPage = response.data.data.pages;
                this.$router.push( { query: { ...this.filterForm } } ).catch( () => {
                } );
            } ).catch(()=>{});
        },
        initUpdate( testing ) {
            this.edit = true;
            this.form.titleRu = testing.titleRu;
            this.form.titleKy = testing.titleKy;
            this.form.documentCode = testing.documentCode;
            this.form.id = testing.id;
            this.form.typeId = testing.type.id;
            this.form.status = testing.status;
            this.form.minLimit = testing.minLimit;
            this.setModal();
        },
        updateTesting() {
            this.axios.put( this.$config.urls.testing.fetchTest.url.replace( ':id', this.form.id ), this.form ).then( () => {
                this.fetchTesting();
                this.snotifySuccess( 'updateSuccessMsg' );
                this.showModal = false;
            } ).catch( () => {
                this.snotifyError( 'serverError' );
            } )
        },
        resetForm() {
            this.form.titleRu = '';
            this.form.titleKy = '';
            this.form.registerPostTypeIds = [];
            this.form.positionTypeIds = [];
            this.regPostAll = false;
            this.postAll = false;
            this.form.documentCode = '';
            this.form.id = null;
            this.form.status = true;
            this.form.typeId = '';
            this.form.minLimit = 1;
            this.edit=false;
        }
    }
};

export default testingMixin;
